import { shape, string, number } from 'prop-types';
import deviceStatus from 'propTypes/deviceStatus';

export default shape({
  id: string,
  name: string,
  status: deviceStatus.isRequired,
  batteryVoltage: number,
  temperature: number,
  numberOfHitsToday: number,
  reportInterval: number,
  lastUpdate: string,
});



// WEBPACK FOOTER //
// ./src/propTypes/trackingDeviceShape.js